<div class="page">
  <app-page-site-switcher [inline]="inline"></app-page-site-switcher>
  <!-- ====== TOP BLOCK ====== -->
  <div class="weekbar" *ngIf="!showHorairesSubpage() && !showInformationsSubpage() && !inline">
    <div class="weekbar-left">
    </div>
    <div class="weekbar-right">
      <button type="button" class="btn-primary-pill" style="padding: 12px 22px;" (click)="openHorairesSubpage()">
        <img src="/assets/schedule.svg" alt="" aria-hidden="true" width="18" height="18" style="margin-right: 8px;" />
        {{ 'etablissement.common.schedule' | translate }}
      </button>
      <!-- <button type="button" class="btn-primary-pill" style="padding: 12px 22px; gap: 8px;" (click)="openInformationsSubpage()">
        <img src="/assets/help.svg" alt="" aria-hidden="true" width="18" height="18" />
        Informations
      </button> -->
    </div>
  </div>

  <!-- Fil d'Ariane pour la sous-page Horaires -->
  <div class="weekbar" *ngIf="showHorairesSubpage() && !inline">
    <div class="breadcrumb">
      <button class="breadcrumb-back" (click)="closeHorairesSubpage()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'etablissement.common.back' | translate }}
      </button>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'etablissement.common.settings' | translate }}</span>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'etablissement.common.schedule' | translate }}</span>
    </div>
  </div>

  <!-- Fil d'Ariane pour la sous-page Informations -->
  <div class="weekbar" *ngIf="showInformationsSubpage() && !inline">
    <div class="breadcrumb">
      <button class="breadcrumb-back" (click)="closeInformationsSubpage()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'etablissement.common.back' | translate }}
      </button>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'etablissement.common.settings' | translate }}</span>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'etablissement.common.informations' | translate }}</span>
    </div>
  </div>
  <!-- ====== /TOP BLOCK ====== -->

  <div class="page-grid" [class.inline]="inline" *ngIf="!showHorairesSubpage() && !showInformationsSubpage()">

    <!-- ─────────── Bloc 1 : Établissement ─────────── -->
    <section class="card card--estab">
      <header class="card__header">
        <h2 class="card__title">{{ 'etablissement.establishment.title' | translate }}</h2>
        <div class="card__actions">
          <button type="button" class="btn btn-primary" (click)="openCreate()">{{ 'etablissement.common.create' | translate }}</button>
        </div>
      </header>

      <form class="form-grid" [formGroup]="infoForm" (ngSubmit)="saveInfo()">
        <div class="form-field name-field">
          <label class="label">{{ 'etablissement.establishment.nameLabel' | translate }}</label>
          <div class="queue-top">
            <input type="text" class="input align-right" formControlName="name" />
            <button
              type="button"
              class="btn-danger-chip"
              [attr.aria-label]="'etablissement.establishment.deleteAriaLabel' | translate"
              (click)="openEstabDelete()">
              <img class="icon-16" src="/assets/delete.svg" alt="" />
            </button>
          </div>
        </div>

        <div class="form-field address-field">
          <label class="label">{{ 'etablissement.establishment.addressLabel' | translate }}</label>
          <textarea class="textarea align-right" rows="2" formControlName="address"></textarea>
        </div>

        <div class="form-field">
          <label class="label">{{ 'etablissement.establishment.placeIdLabel' | translate }}</label>
          <input type="text" class="input align-right" formControlName="place_id" placeholder="ChIJd8BlQ2BZwokRAFUEcm_qrcA" />
        </div>

        <div class="form-field">
          <label class="label">{{ 'etablissement.establishment.websiteLabel' | translate }}</label>
          <input type="text" class="input align-right" formControlName="website" [placeholder]="'etablissement.establishment.websitePlaceholder' | translate" />
        </div>

        <div class="form-field">
          <label class="label">{{ 'etablissement.establishment.languagesLabel' | translate }}</label>
          <div class="language-selector">
            <div class="selected-languages">
              <span *ngFor="let lang of infoForm.get('langues')?.value" class="language-tag">
                <img [src]="flagIcon(lang)" [alt]="getLanguageLabel(lang)" class="language-tag-flag">
                {{ getLanguageLabel(lang) }}
                <button type="button" class="remove-lang" (click)="removeLanguage(lang)"
                        [disabled]="infoForm.get('langues')?.value?.length === 1">×</button>
              </span>
            </div>
            <div class="lang-add-wrap">
              <button type="button" class="lang-add-btn" (click)="toggleAddLangMenu()" [disabled]="remainingPatientLanguages.length === 0">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                {{ 'etablissement.establishment.addLanguagePlaceholder' | translate }}
              </button>
              <ul class="lang-add-menu" *ngIf="addLangMenuOpen()">
                <li *ngFor="let lang of remainingPatientLanguages" class="lang-add-option" (click)="selectLanguageToAdd(lang.code)">
                  <img [src]="flagIcon(lang.code)" [alt]="lang.label" class="language-tag-flag">
                  <span>{{ lang.label }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="form-field">
          <label class="label">{{ 'etablissement.establishment.timezoneLabel' | translate }}</label>
          <select class="input align-right" formControlName="tz">
            <option value="Europe/Paris">Europe/Paris (UTC+1/+2)</option>
            <option value="Africa/Casablanca">Africa/Casablanca (UTC+0/+1)</option>
            <option value="America/Guadeloupe">America/Guadeloupe (UTC-4)</option>
            <option value="America/Martinique">America/Martinique (UTC-4)</option>
            <option value="America/Cayenne">America/Cayenne (UTC-3)</option>
            <option value="Indian/Reunion">Indian/Reunion (UTC+4)</option>
            <option value="Indian/Mayotte">Indian/Mayotte (UTC+3)</option>
            <option value="Pacific/Noumea">Pacific/Noumea (UTC+11)</option>
            <option value="Pacific/Tahiti">Pacific/Tahiti (UTC-10)</option>
          </select>
        </div>

        <div style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; gap: 24px; margin-bottom: 8px;">
          <!-- Doublon retiré (refonte accueil patient) : le motif se règle dans Site › Communication ›
               Paramètres d'affichage. Le contrôle reste dans le formulaire pour renvoyer la valeur à l'identique. -->
          <label class="checkbox-label" style="display: none;">
            <input type="checkbox" class="checkbox-input" formControlName="show_patient_reason" />
            <span class="checkbox-text">{{ 'etablissement.establishment.showPatientReason' | translate }}</span>
          </label>
          <label class="checkbox-label" style="display: none;">
            <input type="checkbox" class="checkbox-input" formControlName="show_end_prestation" />
            <span class="checkbox-text">{{ 'etablissement.establishment.enableEndPrestation' | translate }}</span>
          </label>
        </div>

        <div class="form-actions center">
          <button type="submit" class="btn-primary-pill">{{ 'etablissement.common.save' | translate }}</button>
        </div>
      </form>
    </section>

    <!-- ─────────── Bloc 2 : Motif de visite ─────────── -->
    <section class="card card--queues">
      <header class="card__header">
        <h2 class="card__title">{{ 'etablissement.queues.title' | translate }}</h2>
        <div class="card__actions">
          <button type="button" class="btn btn-primary" (click)="openQueueCreate()">{{ 'etablissement.common.create' | translate }}</button>
        </div>
      </header>

      <div class="card__body">
        <!-- Liste déroulante desktop -->
        <div class="desktop-only">
          <div class="queue-top">
            <select class="select-emph"
                    [ngModel]="selectedQueueId()"
                    (ngModelChange)="selectedQueueId.set($event)">
              <option *ngFor="let q of queues()" [value]="q.id">{{ q.name }}</option>
            </select>

            <button type="button" class="btn-danger-chip"
                    (click)="onDeleteQueue()"
                    [disabled]="!selectedQueue()">
              <img class="icon-16" src="/assets/delete.svg" [attr.alt]="'etablissement.common.delete' | translate" />
            </button>
          </div>
        </div>

        <!-- Carrousel mobile -->
        <div class="queue-carousel mobile-only">
          <div class="carousel-container">
            <div class="carousel-track" [style.transform]="'translateX(' + getCarouselOffset() + 'px)'">
              <div *ngFor="let q of queues(); let i = index"
                   class="carousel-item"
                   [class.active]="q.id === selectedQueueId()"
                   (click)="selectedQueueId.set(q.id)">
                <span class="queue-name">{{ q.name }}</span>
                <button type="button" class="btn-delete-mini" (click)="onDeleteQueue(); $event.stopPropagation()">
                  <img class="icon-12" src="/assets/delete.svg" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Formulaire de la file sélectionnée -->
        <ng-container *ngIf="selectedQueue() as q">
          <form class="form-grid" [formGroup]="queueForms[q.id]">
            <div class="form-field">
              <label class="label">{{ 'etablissement.queues.nameLabelFr' | translate }}</label>
              <input class="input align-right" formControlName="name" />
            </div>

            <!-- Champs i18n pour les autres langues -->
            <ng-container *ngFor="let lang of getLanguages()">
              <div class="form-field" *ngIf="lang !== 'fr'">
                <label class="label">{{ 'etablissement.queues.nameLabelLang' | translate: { lang: (lang === 'ar' ? 'AR' : lang.toUpperCase()) } }}</label>
                <input class="input align-right" [formControlName]="'name_' + lang" [dir]="lang === 'ar' ? 'rtl' : 'ltr'" />
              </div>
            </ng-container>

            <div class="form-field">
              <label class="label">{{ 'etablissement.queues.messageLabelFr' | translate }}</label>
              <textarea class="textarea align-right" rows="3"
                        formControlName="patient_message"
                        [placeholder]="'etablissement.queues.messagePlaceholder' | translate"></textarea>
            </div>

            <!-- Champs i18n pour les autres langues -->
            <ng-container *ngFor="let lang of getLanguages()">
              <div class="form-field" *ngIf="lang !== 'fr'">
                <label class="label">{{ 'etablissement.queues.messageLabelLang' | translate: { lang: (lang === 'ar' ? 'AR' : lang.toUpperCase()) } }}</label>
                <textarea class="textarea align-right" rows="3"
                          [formControlName]="'patient_message_' + lang"
                          [dir]="lang === 'ar' ? 'rtl' : 'ltr'"></textarea>
              </div>
            </ng-container>
          </form>

          <div class="form-actions center">
            <button type="button" class="btn-primary-pill" (click)="saveSelectedQueue()">{{ 'etablissement.common.save' | translate }}</button>
          </div>
        </ng-container>

        <ng-container *ngIf="!queues()?.length">
          <div class="muted">{{ 'etablissement.queues.empty' | translate }}</div>
        </ng-container>
      </div>
    </section>

  </div>

  <!-- Sous-page Horaires -->
  <div class="horaires-subpage" *ngIf="showHorairesSubpage()">
    <app-horaires></app-horaires>
  </div>

  <!-- Sous-page Informations -->
  <div class="informations-subpage" *ngIf="showInformationsSubpage()">
    <app-informations></app-informations>
  </div>

  <!-- Toast succès -->
  <div class="ora-toast" *ngIf="toastVisible" role="status" aria-live="assertive">
    <span class="ora-ico-badge" aria-hidden="true">
      <img class="ora-ico" src="assets/IconORA.svg" alt="">
    </span>
    <span class="ora-txt">
      <span class="ora-title">{{ 'etablissement.toast.title' | translate }}</span>
      <span class="ora-sub">{{ toastSubtitle }}</span>
    </span>
  </div>

  <!-- Modale création établissement -->
  <app-estab-create-modal
    *ngIf="createOpen()"
    (close)="closeCreate()"
    (created)="onCreatedEstab($event)">
  </app-estab-create-modal>

  <!-- Modale de contact pour création -->
  <div class="modal"
       *ngIf="showContactModal()"
       tabindex="0"
       (click)="closeContactModal()"
       (keydown.escape)="closeContactModal()">
    <div class="modal__panel"
         role="dialog"
         aria-modal="true"
         (click)="$event.stopPropagation()">
      <header class="modal__header">
        <h3>{{ 'etablissement.modals.contact.title' | translate }}</h3>
      </header>
      <div class="modal__body">
        <p *ngIf="contactModalType() === 'creation'">{{ 'etablissement.modals.contact.creationText' | translate }}</p>
        <p *ngIf="contactModalType() === 'deletion'">{{ 'etablissement.modals.contact.deletionText' | translate }}</p>
        <p>{{ 'etablissement.modals.contact.question' | translate }}</p>
      </div>
      <footer class="modal__footer">
        <button type="button" class="btn" (click)="closeContactModal()">{{ 'etablissement.common.cancel' | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="contactSupport()">{{ 'etablissement.modals.contact.contactSupport' | translate }}</button>
      </footer>
    </div>
  </div>

  <!-- Modale création file -->
  <app-queue-create-modal
    *ngIf="queueCreateOpen() && id"
    [estabId]="id!"
    [langues]="infoForm.get('langues')?.value ?? ['fr']"
    (close)="closeQueueCreate()"
    (created)="onCreatedQueue($event)">
  </app-queue-create-modal>

  <!-- Modale de confirmation suppression FILE -->
  <div class="modal"
       *ngIf="deleteConfirmOpen()"
       tabindex="0"
       (click)="closeDeleteConfirm()"
       (keydown.escape)="closeDeleteConfirm()">
    <div class="modal__panel"
         role="dialog"
         aria-modal="true"
         aria-labelledby="dlg-title"
         (click)="$event.stopPropagation()">
      <header class="modal__header">
        <h3 id="dlg-title">
          {{ 'etablissement.modals.deleteQueue.title' | translate: { name: (deleteTarget()?.name || selectedQueue()?.name) } }}
        </h3>
      </header>

      <div class="modal__body">
        <p>{{ 'etablissement.modals.deleteQueue.body' | translate }}</p>
      </div>

      <footer class="modal__footer">
        <button type="button" class="btn" (click)="closeDeleteConfirm()">{{ 'etablissement.common.cancel' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="confirmDelete()">{{ 'etablissement.common.delete' | translate }}</button>
      </footer>
    </div>
  </div>

  <!-- Modale de confirmation suppression ETABLISSEMENT -->
  <div class="modal"
       *ngIf="estabDeleteOpen()"
       tabindex="0"
       (click)="closeEstabDelete()"
       (keydown.escape)="closeEstabDelete()">
    <div class="modal__panel"
         role="dialog"
         aria-modal="true"
         aria-labelledby="dlg-estab-title"
         (click)="$event.stopPropagation()">
      <header class="modal__header">
        <h3 id="dlg-estab-title">
          {{ 'etablissement.modals.deleteEstablishment.title' | translate: { name: (infoForm.get('name')?.value || '—') } }}
        </h3>
      </header>

      <div class="modal__body">
        <p [innerHTML]="'etablissement.modals.deleteEstablishment.body' | translate"></p>
      </div>

      <footer class="modal__footer">
        <button type="button" class="btn" (click)="closeEstabDelete()">{{ 'etablissement.common.cancel' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="confirmEstabDelete()">{{ 'etablissement.common.delete' | translate }}</button>
      </footer>
    </div>
  </div>
</div>
